export const defaultMarkersStatus = [
	'BEING_PREPARED', 'READY', 'ON_THE_WAY',
]
